import axios from "axios";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import Url from "../../apiBaseUrl/APIConfig";
import { GetAuditListRes, GetAuditListReq, PatientList } from "./Model";
import { setupInterceptorsTo } from "../authenticationInterceptors/Interceptors";

type InitialState = {
  loading: boolean;
  response: GetAuditListRes;
  successMsg: string;
  error: string;
  drawerOpen?: boolean;
  selectedAuditDetails?: PatientList | null;
};
const initialState: InitialState = {
  loading: false,
  response: {} as GetAuditListRes,
  successMsg: "",
  error: "",
  drawerOpen: false,
  selectedAuditDetails : null
};


export const getAuditList = createAsyncThunk<GetAuditListRes, GetAuditListReq>(
  "getAuditList/getAuditList",
  (payload: GetAuditListReq, { rejectWithValue }) => {
    const headers = {
      Accept: "application/json",
      "Content-type": "application/json",
      Authorization: `Bearer ${payload.access}`,
    };
    return  setupInterceptorsTo(axios)
      .post(Url.baseUrl + `/caregiverapp/api/healthcamppatient/patient_list_of_healthcamp?page=${Number(
        payload.pageNo,
          )}&size=${Number(
            payload.rowSize,
          )}`, 
        payload.body, 
        { headers})
      .then((response) => response.data)
      .catch((error) =>
        rejectWithValue(
          error?.response?.data !== undefined
            ? error?.response?.data[0]?.description !== undefined
              ? error?.response?.data[0]?.description
              : error.response.data.message !== undefined
              ? error.response.data.message
              : 'Something Went Wrong.'
            : 'Something Went Wrong.',
        ),
      )
  }
);

const getAuditListSlice = createSlice({
  name: "getAuditList",
  initialState,
  reducers: {
    updateGetAuditListClearMsg: (state) => {
      state.successMsg = "";
      state.error = "";
    },
    updateGetAuditListClearRes: (state) => {
      state.successMsg = "";
      state.error = "";
      state.response = {} as GetAuditListRes;
    },
    clearGetAuditList: (state) => {
      state.response = {} as GetAuditListRes;
      state.loading = false;
      state.error = "";
    },
    togglreAuditDetailsDrawerState: (state, action) => {
      state.drawerOpen = action.payload
    },
    selectedAuditItemDetails: (state, action) => {
      state.selectedAuditDetails = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getAuditList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getAuditList.fulfilled,
      (state, action: PayloadAction<GetAuditListRes>) => {
        state.loading = false;
        state.response = action.payload;
      }
    );
    builder.addCase(getAuditList.rejected, (state, action) => {
      state.loading = false;
      state.response = {} as GetAuditListRes;
      state.successMsg = "";
      state.error = String(action.payload!);
    });
  },
});
export const { updateGetAuditListClearMsg, updateGetAuditListClearRes, clearGetAuditList, togglreAuditDetailsDrawerState, selectedAuditItemDetails } = getAuditListSlice.actions;
export default getAuditListSlice.reducer;
